(function () {
  'use strict';
  if (!window.customElements || customElements.get('rn-krisencheck')) return;

  var SPECIES = ['dog', 'cat', 'small', 'other', 'none'];
  var SPECIES_TAG = { dog: 'hund', cat: 'katze', small: 'kleintier', other: 'andere', none: 'keine' };
  var GROUPS = [
    { w: 3, label: 'Zuerst erledigen', pdf: '#C9492E' },
    { w: 2, label: 'Als Nächstes', pdf: '#D39B2A' },
    { w: 1, label: 'Wenn Zeit ist', pdf: '#9C978A' }
  ];
  var MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

  function q(root, sel) { return root.querySelector(sel); }
  function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function addMonths(date, m) {
    var d = new Date(date.getFullYear(), date.getMonth() + m, 1);
    var last = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
    d.setDate(Math.min(date.getDate(), last));
    return d;
  }
  function fmtDate(d) { return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear(); }
  function fmtMonth(d) { return MONTHS[d.getMonth()] + ' ' + d.getFullYear(); }
  function ymd(d) { return d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()); }
  function reduced() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function uniq(list) { return list.filter(function (v, i) { return v && list.indexOf(v) === i; }); }

  function download(data, filename, type) {
    var blob = data instanceof Blob ? data : new Blob([data], { type: type });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.rel = 'noopener';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    setTimeout(function () { URL.revokeObjectURL(url); a.remove(); }, 2000);
  }
  function icsEscape(s) { return String(s).replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n'); }
  function icsFold(line) {
    var enc = new TextEncoder();
    if (enc.encode(line).length <= 75) return line;
    var out = [], cur = '', bytes = 0;
    Array.from(line).forEach(function (ch) {
      var b = enc.encode(ch).length;
      if (bytes + b > 75) { out.push(cur); cur = ' ' + ch; bytes = 1 + b; }
      else { cur += ch; bytes += b; }
    });
    out.push(cur);
    return out.join('\r\n');
  }

  /* ── Mini-PDF (Helvetica, WinAnsi) – ohne externe Bibliothek ─────────── */
  var PDF = (function () {
    var WR = [278,278,355,556,556,889,667,191,333,333,389,584,278,333,278,278,556,556,556,556,556,556,556,556,556,556,278,278,584,584,584,556,1015,667,667,722,722,667,611,778,722,278,500,667,556,833,722,778,667,778,722,667,611,722,667,944,667,667,611,278,278,278,469,556,333,556,556,500,556,556,278,556,556,222,222,500,222,833,556,556,556,556,333,500,278,556,500,722,500,500,500,334,260,334,584,278,556,278,222,556,333,1000,556,556,333,1000,667,333,1000,278,611,278,278,222,222,333,333,350,556,1000,333,1000,500,333,944,278,500,667,278,333,556,556,556,556,260,556,333,737,370,556,584,333,737,333,400,584,278,278,333,556,537,278,333,278,365,556,834,834,834,611,667,667,667,667,667,667,1000,722,667,667,667,667,278,278,278,278,722,722,778,778,778,778,778,584,778,722,722,722,722,667,667,611,556,556,556,556,556,556,889,500,556,556,556,556,278,278,278,278,556,556,556,556,556,556,556,584,611,556,556,556,556,500,556,500];
    var WB = [278,333,474,556,556,889,722,238,333,333,389,584,278,333,278,278,556,556,556,556,556,556,556,556,556,556,333,333,584,584,584,611,975,722,722,722,722,667,611,778,722,278,556,722,611,833,722,778,667,778,722,667,611,722,667,944,667,667,611,333,278,333,584,556,333,556,611,556,611,556,333,611,611,278,278,556,278,889,611,611,611,611,389,556,333,611,556,778,556,556,500,389,280,389,584,278,556,278,278,556,500,1000,556,556,333,1000,667,333,1000,278,611,278,278,278,278,500,500,350,556,1000,333,1000,556,333,944,278,500,667,278,333,556,556,556,556,280,556,333,737,370,556,584,333,737,333,400,584,278,278,333,611,556,278,333,278,365,556,834,834,834,611,722,722,722,722,722,722,1000,722,667,667,667,667,278,278,278,278,722,722,778,778,778,778,778,584,778,722,722,722,722,667,667,611,556,556,556,556,556,556,889,556,556,556,556,556,278,278,278,278,611,611,611,611,611,611,611,584,611,611,611,611,611,556,611,556];
    var MAP = { 8364: 128, 8218: 130, 402: 131, 8222: 132, 8230: 133, 8224: 134, 8225: 135, 710: 136, 8240: 137, 352: 138, 8249: 139, 338: 140, 381: 142, 8216: 145, 8217: 146, 8220: 147, 8221: 148, 8226: 149, 8211: 150, 8212: 151, 732: 152, 8482: 153, 353: 154, 8250: 155, 339: 156, 382: 158, 376: 159 };

    function toWin(str) {
      var out = '';
      var s = String(str == null ? '' : str);
      if (s.normalize) s = s.normalize('NFC');
      for (var i = 0; i < s.length; i++) {
        var c = s.codePointAt(i);
        if (c > 0xFFFF) { i++; continue; }
        if (c === 0x2192) { out += '->'; continue; }
        if (c === 0x00A0 || c === 0x2009 || c === 0x202F || c === 0x2007) { out += ' '; continue; }
        if (c === 0x2212 || c === 0x2010 || c === 0x2011) { out += '-'; continue; }
        if (c < 0x20) continue;
        if (c < 0x7F) { out += s.charAt(i); continue; }
        if (c >= 0x80 && c <= 0xFF && c !== 0xA0) { out += String.fromCharCode(c); continue; } /* bereits WinAnsi oder Latin-1 */
        if (MAP[c]) { out += String.fromCharCode(MAP[c]); continue; }
      }
      return out;
    }
    function width(str, bold, size) {
      var t = bold ? WB : WR, sum = 0;
      for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        sum += (c >= 32 && c <= 255) ? t[c - 32] : 500;
      }
      return sum * size / 1000;
    }
    function wrap(str, bold, size, max) {
      var words = toWin(str).split(' '), lines = [], cur = '';
      words.forEach(function (word) {
        var test = cur ? cur + ' ' + word : word;
        if (width(test, bold, size) <= max) { cur = test; return; }
        if (cur) lines.push(cur);
        while (word && width(word, bold, size) > max) {
          var k = word.length;
          while (k > 1 && width(word.slice(0, k), bold, size) > max) k--;
          lines.push(word.slice(0, k));
          word = word.slice(k);
        }
        cur = word;
      });
      if (cur) lines.push(cur);
      return lines;
    }
    function esc(s) { return s.replace(/\\/g, '\\\\').replace(/\(/g, '\\(').replace(/\)/g, '\\)'); }
    function utf16(s) {
      var hex = 'FEFF';
      for (var i = 0; i < s.length; i++) hex += ('000' + s.charCodeAt(i).toString(16).toUpperCase()).slice(-4);
      return '<' + hex + '>';
    }
    function asciiUrl(u) { return String(u).replace(/[^\x21-\x7E]/g, function (ch) { return encodeURIComponent(ch); }); }
    function num(n) { return String(Math.round(n * 100) / 100); }
    function rgb(hex) {
      var h = String(hex).replace('#', '');
      return [0, 2, 4].map(function (k) { return num(parseInt(h.slice(k, k + 2), 16) / 255); }).join(' ');
    }

    function Doc() { this.W = 595.28; this.H = 841.89; this.pages = []; this.addPage(); }
    Doc.prototype.addPage = function () { this.page = { ops: [], links: [] }; this.pages.push(this.page); };
    Doc.prototype.op = function (s) { this.page.ops.push(s); };
    /* y = Grundlinie, gemessen von oben */
    Doc.prototype.text = function (x, y, s, o) {
      o = o || {};
      var size = o.size || 10, str = toWin(s), cs = o.cs || 0;
      if (!str) return 0;
      this.op('BT /' + (o.bold ? 'F2' : 'F1') + ' ' + num(size) + ' Tf ' + num(cs) + ' Tc ' + rgb(o.color || '#1A1E26') +
        ' rg 1 0 0 1 ' + num(x) + ' ' + num(this.H - y) + ' Tm (' + esc(str) + ') Tj ET');
      return width(str, o.bold, size) + cs * str.length;
    };
    Doc.prototype.rect = function (x, y, w, h, o) {
      o = o || {};
      var s = '';
      if (o.fill) s += rgb(o.fill) + ' rg ';
      if (o.stroke) s += rgb(o.stroke) + ' RG ' + num(o.lw || 1) + ' w ';
      s += num(x) + ' ' + num(this.H - y - h) + ' ' + num(w) + ' ' + num(h) + ' re ' + (o.fill && o.stroke ? 'B' : (o.fill ? 'f' : 'S'));
      this.op(s);
    };
    Doc.prototype.line = function (x1, y1, x2, y2, o) {
      o = o || {};
      this.op(rgb(o.color || '#D9D2C2') + ' RG ' + num(o.lw || 0.6) + ' w ' + (o.dash ? '[' + o.dash + '] 0 d ' : '') +
        num(x1) + ' ' + num(this.H - y1) + ' m ' + num(x2) + ' ' + num(this.H - y2) + ' l S' + (o.dash ? ' [] 0 d' : ''));
    };
    Doc.prototype.check = function (x, y, s, color) {
      this.op(rgb(color) + ' RG 1.4 w 1 J 1 j ' + num(x) + ' ' + num(this.H - y + s * 0.45) + ' m ' +
        num(x + s * 0.35) + ' ' + num(this.H - y + s * 0.1) + ' l ' + num(x + s) + ' ' + num(this.H - y + s * 0.85) + ' l S 0 J 0 j');
    };
    /* Kreisbogen im Uhrzeigersinn, 0° = oben */
    Doc.prototype.arc = function (cx, cy, r, a0, a1, o) {
      var yc = this.H - cy, segs = Math.max(1, Math.ceil(Math.abs(a1 - a0) / 90)), step = (a1 - a0) / segs;
      var rad = function (deg) { return (90 - deg) * Math.PI / 180; };
      var ops = [num(cx + r * Math.cos(rad(a0))) + ' ' + num(yc + r * Math.sin(rad(a0))) + ' m'];
      for (var i = 0; i < segs; i++) {
        var t0 = rad(a0 + i * step), t1 = rad(a0 + (i + 1) * step), k = 4 / 3 * Math.tan((t1 - t0) / 4);
        var x0 = cx + r * Math.cos(t0), y0 = yc + r * Math.sin(t0), x3 = cx + r * Math.cos(t1), y3 = yc + r * Math.sin(t1);
        ops.push([x0 - k * r * Math.sin(t0), y0 + k * r * Math.cos(t0), x3 + k * r * Math.sin(t1), y3 - k * r * Math.cos(t1), x3, y3].map(num).join(' ') + ' c');
      }
      this.op(rgb(o.color) + ' RG ' + num(o.lw || 6) + ' w ' + (o.cap ? '1' : '0') + ' J ' + ops.join(' ') + ' S 0 J');
    };
    Doc.prototype.link = function (x, yTop, w, h, url) { this.page.links.push([x, this.H - yTop - h, x + w, this.H - yTop, url]); };
    Doc.prototype.output = function (info) {
      var objs = [], self = this;
      var add = function (s) { objs.push(s); return objs.length; };
      var catalog = add(''), pagesId = add('');
      var f1 = add('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>');
      var f2 = add('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>');
      var kids = [];
      this.pages.forEach(function (p) {
        var content = p.ops.join('\n');
        var cId = add('<< /Length ' + content.length + ' >>\nstream\n' + content + '\nendstream');
        var annots = p.links.map(function (l) {
          return add('<< /Type /Annot /Subtype /Link /Rect [' + [l[0], l[1], l[2], l[3]].map(num).join(' ') +
            '] /Border [0 0 0] /A << /S /URI /URI (' + esc(asciiUrl(l[4])) + ') >> >>');
        });
        kids.push(add('<< /Type /Page /Parent ' + pagesId + ' 0 R /MediaBox [0 0 ' + num(self.W) + ' ' + num(self.H) +
          '] /Resources << /Font << /F1 ' + f1 + ' 0 R /F2 ' + f2 + ' 0 R >> >> /Contents ' + cId + ' 0 R' +
          (annots.length ? ' /Annots [' + annots.map(function (a) { return a + ' 0 R'; }).join(' ') + ']' : '') + ' >>'));
      });
      objs[catalog - 1] = '<< /Type /Catalog /Pages ' + pagesId + ' 0 R >>';
      objs[pagesId - 1] = '<< /Type /Pages /Kids [' + kids.map(function (k) { return k + ' 0 R'; }).join(' ') + '] /Count ' + kids.length + ' >>';
      var infoId = add('<< /Title ' + utf16(info.title || '') + ' /Producer ' + utf16(info.producer || '') + ' /CreationDate (D:' + info.date + ') >>');
      var out = '%PDF-1.4\n%âãÏÓ\n', offsets = [];
      objs.forEach(function (o, i) { offsets.push(out.length); out += (i + 1) + ' 0 obj\n' + o + '\nendobj\n'; });
      var xref = out.length;
      out += 'xref\n0 ' + (objs.length + 1) + '\n0000000000 65535 f \n';
      offsets.forEach(function (off) { out += ('0000000000' + off).slice(-10) + ' 00000 n \n'; });
      out += 'trailer\n<< /Size ' + (objs.length + 1) + ' /Root ' + catalog + ' 0 R /Info ' + infoId + ' 0 R >>\nstartxref\n' + xref + '\n%%EOF\n';
      var bytes = new Uint8Array(out.length);
      for (var i = 0; i < out.length; i++) bytes[i] = out.charCodeAt(i) & 255;
      return bytes;
    };
    return { Doc: Doc, width: width, wrap: wrap, toWin: toWin };
  })();

  function buildPdf(d) {
    var doc = new PDF.Doc(), W = doc.W, H = doc.H, M = 48, CW = W - 2 * M, y;
    var C = { ink: '#1A1E26', body: '#3A3B40', muted: '#6B6A63', line: '#D9D2C2', navy: '#0E2A47', track: '#2B4764',
      paper: '#F6F2EA', blue: '#2B8FCC', blue2: '#4FB0E5', light: '#F2EFE2', soft: '#CBC7B8',
      good: '#3F8F5F', warn: '#D39B2A', bad: '#C9492E', low: '#9C978A' };
    var bandColor = { high: C.good, mid: C.warn, low: C.bad }[d.band] || C.bad;
    var BOTTOM = H - 78;
    var need = function (h) {
      if (y + h <= BOTTOM) return false;
      doc.addPage();
      doc.text(M, 44, 'KRISENCHECK  ·  TO-DO-LISTE (FORTSETZUNG)', { size: 7.5, cs: 1.2, color: C.muted });
      y = 76;
      return true;
    };

    /* Kopf */
    doc.rect(0, 0, W, 150, { fill: C.navy });
    doc.text(M, 46, ((d.shop ? d.shop + '  ·  ' : '') + 'Krisencheck').toUpperCase(), { size: 8, cs: 1.5, color: C.blue2 });
    doc.text(M, 84, d.title, { size: 23, bold: true, color: C.light });
    doc.text(M, 106, 'Erstellt am ' + d.date + '  ·  Nächster Check: ' + d.next, { size: 9.5, color: C.soft });
    var cx = W - M - 44, cy = 76, r = 40;
    doc.arc(cx, cy, r, 0, 359.9, { color: C.track, lw: 7 });
    if (d.pct > 0) doc.arc(cx, cy, r, 0, Math.min(359.9, 3.6 * d.pct), { color: bandColor, lw: 7, cap: true });
    var pctStr = d.pct + ' %', pw = PDF.width(PDF.toWin(pctStr), true, 19);
    doc.text(cx - pw / 2, cy + 4, pctStr, { size: 19, bold: true, color: C.light });
    var lab = 'VORBEREITET', lw = PDF.width(lab, false, 6) + 0.8 * lab.length;
    doc.text(cx - lw / 2, cy + 16, lab, { size: 6, cs: 0.8, color: C.soft });

    /* Urteil */
    y = 190;
    PDF.wrap(d.bandTitle, true, 15, CW).forEach(function (l) { doc.text(M, y, l, { size: 15, bold: true }); y += 19; });
    y += 1;
    PDF.wrap(d.bandText, false, 10.5, CW).forEach(function (l) { doc.text(M, y, l, { size: 10.5, color: C.body }); y += 15; });
    y += 9;
    doc.text(M, y, (d.done + ' von ' + d.count + ' Punkten erledigt  ·  ' + d.crit + ' wichtige ' + (d.crit === 1 ? 'Lücke' : 'Lücken')).toUpperCase(), { size: 7.5, cs: 1, color: C.muted });
    y += 22;

    /* To-do-Gruppen */
    if (!d.groups.length) {
      need(60);
      doc.line(M, y, W - M, y, { color: C.line });
      y += 26;
      doc.text(M, y, 'Alles erledigt – stark!', { size: 13, bold: true });
      y += 17;
      doc.text(M, y, 'Prüfe deine Vorräte trotzdem regelmäßig: Haltbarkeit, Batterien, Powerbank.', { size: 10.5, color: C.body });
      y += 20;
    }
    d.groups.forEach(function (g) {
      need(56);
      doc.line(M, y, W - M, y, { color: C.line });
      y += 22;
      doc.rect(M + 1, y - 7.5, 7.5, 7.5, { stroke: g.color, lw: 1.6 });
      doc.text(M + 16, y, (g.label + '  ·  ' + g.items.length).toUpperCase(), { size: 8, bold: true, cs: 1, color: C.ink });
      y += 20;
      g.items.forEach(function (it, idx) {
        var tl = PDF.wrap(it.text, false, 11, CW - 24);
        var h = (tl.length - 1) * 14.5 + (it.note ? 13 : 0);
        var broke = need(h + 24);
        if (idx > 0 && !broke) { doc.line(M + 24, y - 15, W - M, y - 15, { color: C.line, lw: 0.5, dash: '1.2 2.2' }); }
        doc.rect(M + 0.5, y - 9, 10, 10, { stroke: C.ink, lw: 0.9 });
        tl.forEach(function (l, k) { doc.text(M + 24, y + k * 14.5, l, { size: 11, color: C.ink }); });
        var yy = y + (tl.length - 1) * 14.5;
        if (it.note) {
          yy += 13;
          var nw = doc.text(M + 24, yy, '» ' + it.note, { size: 8.5, color: C.blue });
          if (it.url) doc.link(M + 24, yy - 8.5, nw, 11.5, it.url);
        }
        y = yy + 25;
      });
      y += 2;
    });

    /* Produkte */
    if (d.products.length) {
      need(80);
      doc.line(M, y, W - M, y, { color: C.line });
      y += 22;
      doc.text(M, y, 'PASSENDE AUSRÜSTUNG', { size: 8, bold: true, cs: 1 });
      y += 14;
      d.products.forEach(function (p) {
        var cl = PDF.wrap('Deckt ab: ' + p.covers.join(', '), false, 9, CW - 28);
        var h = 44 + cl.length * 12 + 12;
        need(h + 12);
        doc.rect(M, y, CW, h, { fill: C.paper });
        doc.text(M + 14, y + 22, p.title, { size: 11.5, bold: true });
        if (p.price) { var pr = PDF.toWin(p.price); doc.text(W - M - 14 - PDF.width(pr, true, 10), y + 22, pr, { size: 10, bold: true }); }
        cl.forEach(function (l, k) { doc.text(M + 14, y + 38 + k * 12, l, { size: 9, color: C.body }); });
        var uy = y + 38 + cl.length * 12 + 4;
        var shown = p.url.replace(/^https?:\/\//, '');
        var uw = doc.text(M + 14, uy, shown, { size: 8.5, color: C.blue });
        doc.link(M + 14, uy - 8.5, uw, 11.5, p.url);
        y += h + 10;
      });
      y += 6;
    }

    /* Erledigt */
    if (d.doneItems.length) {
      need(60);
      doc.line(M, y, W - M, y, { color: C.line });
      y += 22;
      doc.text(M, y, ('Schon erledigt  ·  ' + d.doneItems.length).toUpperCase(), { size: 8, bold: true, cs: 1, color: C.good });
      y += 18;
      var colW = (CW - 28) / 2;
      for (var i = 0; i < d.doneItems.length; i += 2) {
        var a = PDF.wrap(d.doneItems[i], false, 9, colW - 16);
        var b = d.doneItems[i + 1] ? PDF.wrap(d.doneItems[i + 1], false, 9, colW - 16) : [];
        var rows = Math.max(a.length, b.length);
        need(rows * 11.5 + 8);
        [[a, M], [b, M + colW + 28]].forEach(function (pair) {
          if (!pair[0].length) return;
          doc.check(pair[1], y - 1, 7, C.good);
          pair[0].forEach(function (l, k) { doc.text(pair[1] + 14, y + k * 11.5, l, { size: 9, color: C.body }); });
        });
        y += rows * 11.5 + 7;
      }
      y += 4;
    }

    /* Abschluss */
    need(64);
    doc.line(M, y, W - M, y, { color: C.line });
    y += 20;
    var lead = 'Dein Ergebnis online öffnen: ';
    var lw2 = doc.text(M, y, lead, { size: 9, bold: true });
    var ru = d.resultUrl.replace(/^https?:\/\//, '');
    if (PDF.width(PDF.toWin(ru), false, 9) > CW - lw2) ru = ru.slice(0, 64) + '…';
    var rw = doc.text(M + lw2, y, ru, { size: 9, color: C.blue });
    doc.link(M + lw2, y - 9, rw, 12, d.resultUrl);
    y += 16;
    if (d.disclaimer) {
      PDF.wrap(d.disclaimer, false, 7.5, CW).forEach(function (l) { doc.text(M, y, l, { size: 7.5, color: C.muted }); y += 10; });
    }

    /* Fußzeilen */
    var total = doc.pages.length;
    doc.pages.forEach(function (p, i) {
      doc.page = p;
      doc.line(M, H - 48, W - M, H - 48, { color: C.line });
      var u = d.pageUrl.replace(/^https?:\/\//, '');
      var uw2 = doc.text(M, H - 32, u, { size: 8, color: C.blue });
      doc.link(M, H - 40, uw2, 11, d.pageUrl);
      var pg = 'Seite ' + (i + 1) + ' von ' + total;
      doc.text(W - M - PDF.width(pg, false, 8), H - 32, pg, { size: 8, color: C.muted });
    });

    var now = new Date(), p2 = function (n) { return (n < 10 ? '0' : '') + n; };
    return doc.output({
      title: 'Krisencheck – To-do-Liste',
      producer: (d.shop ? d.shop + ' ' : '') + 'Krisencheck',
      date: now.getFullYear() + p2(now.getMonth() + 1) + p2(now.getDate()) + p2(now.getHours()) + p2(now.getMinutes()) + p2(now.getSeconds())
    });
  }


  class RNKrisencheck extends HTMLElement {
    connectedCallback() {
      if (!this._ready) { this._ready = true; this.init(); }
      if (this.cfg.design && !this._onSelect) {
        var self = this;
        this._onSelect = function (e) { if (self.contains(e.target)) self.editorSelect(e.target); };
        document.addEventListener('shopify:block:select', this._onSelect);
      }
    }
    disconnectedCallback() {
      if (this._onSelect) { document.removeEventListener('shopify:block:select', this._onSelect); this._onSelect = null; }
    }

    init() {
      var cfgEl = q(this, '[data-kc-config]');
      try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) { this.cfg = {}; }
      this.cfg.high = parseInt(this.cfg.high, 10) || 90;
      this.cfg.mid = Math.min(parseInt(this.cfg.mid, 10) || 60, this.cfg.high - 5);
      this.cfg.months = parseInt(this.cfg.months, 10) || 6;
      this.cfg.bands = this.cfg.bands || {};
      this.cfg.design = !!(this.cfg.design || (window.Shopify && window.Shopify.designMode));
      this.classList.add('is-js');

      this.el = {
        intro: q(this, '[data-kc-screen="intro"]'),
        quiz: q(this, '[data-kc-quiz]'),
        result: q(this, '[data-kc-screen="result"]'),
        progress: q(this, '[data-kc-progress]'),
        progressLabel: q(this, '[data-kc-progress-label]'),
        live: q(this, '.rn-kc__live'),
        liveRing: q(this, '[data-kc-live-ring]'),
        liveScore: q(this, '[data-kc-live-score]'),
        next: q(this, '[data-kc-next]'),
        nextLabel: q(this, '[data-kc-next-label]'),
        petsHint: q(this, '[data-kc-pets-hint]'),
        status: q(this, '[data-kc-status]')
      };
      this.steps = qa(this, '[data-kc-step]');
      this.petStep = q(this, '[data-kc-step="pets"]');
      this.items = qa(this, '[data-kc-item]');
      this.speciesInputs = qa(this, '[data-kc-species]');
      this.index = 0;
      this.bind();
      if (!this.restore()) this.show('intro');
    }

    bind() {
      var self = this;
      this.addEventListener('click', function (e) {
        var t = e.target.closest('button, a');
        if (!t || !self.contains(t)) return;
        if (t.hasAttribute('data-kc-start')) self.start();
        else if (t.hasAttribute('data-kc-next')) self.next();
        else if (t.hasAttribute('data-kc-prev')) self.prev();
        else if (t.hasAttribute('data-kc-restart')) self.restart();
        else if (t.hasAttribute('data-kc-pdf')) self.downloadPdf();
        else if (t.hasAttribute('data-kc-mail')) self.sendMail();
        else if (t.hasAttribute('data-kc-rem-toggle')) self.toggleReminder(t);
        else if (t.hasAttribute('data-kc-ics')) self.downloadIcs();
        else if (t.hasAttribute('data-kc-gcal')) self.setStatus('Google Kalender öffnet sich in einem neuen Tab.');
        else if (t.hasAttribute('data-kc-goto')) self.editorGoto(t.getAttribute('data-kc-goto'));
      });
      this.addEventListener('change', function (e) {
        var t = e.target;
        if (t.hasAttribute('data-kc-species')) self.onSpecies(t);
        else if (t.hasAttribute('data-kc-item')) self.updateLive();
      });
      var form = q(this, '.rn-kc__form');
      if (form) form.addEventListener('submit', function () { self.beforeLeadSubmit(); });
    }

    /* ── Zustand ─────────────────────────────────────────────── */
    species() {
      var s = {};
      this.speciesInputs.forEach(function (i) { if (i.checked) s[i.value] = true; });
      return s;
    }
    hasChoice() { return !this.petStep || this.speciesInputs.some(function (i) { return i.checked; }); }
    noPets() { return !!this.petStep && !!this.species().none; }
    hasPets() {
      if (!this.petStep) return true;
      var s = this.species();
      return !!(s.dog || s.cat || s.small || s.other);
    }
    weight(i) { var w = parseInt(i.getAttribute('data-w'), 10); return (w === 3 || w === 1) ? w : 2; }
    stepOf(i) { return i.closest('[data-kc-step]'); }
    stepActive(step) {
      if (!step || step === this.petStep) return true;
      return !(this.petStep && step.getAttribute('data-kc-pet') === 'true' && this.noPets());
    }
    applies(i) {
      if (!this.stepActive(this.stepOf(i))) return false;
      if (!this.petStep) return true;
      var list = (i.getAttribute('data-species') || '').split(/\s+/).filter(Boolean);
      if (!list.length) return true;
      var s = this.species();
      return list.some(function (x) { return s[x]; });
    }
    applyFilters() {
      var self = this;
      this.items.forEach(function (i) { var li = i.closest('[data-kc-li]'); if (li) li.hidden = !self.applies(i); });
    }
    flow() {
      var self = this;
      return this.steps.filter(function (step) {
        if (step === self.petStep) return true;
        if (!self.stepActive(step)) return false;
        return qa(step, '[data-kc-item]').some(function (i) { return self.applies(i); });
      });
    }
    score() {
      var self = this, total = 0, got = 0, done = 0, count = 0, crit = 0;
      this.items.forEach(function (i) {
        if (!self.applies(i)) return;
        var w = self.weight(i);
        total += w; count++;
        if (i.checked) { got += w; done++; } else if (w === 3) crit++;
      });
      var pct = total ? Math.round(got / total * 100) : 0;
      if (pct === 100 && done < count) pct = 99;
      if (pct === 0 && done > 0) pct = 1;
      return { pct: pct, done: done, count: count, crit: crit };
    }
    band(pct) { return pct >= this.cfg.high ? 'high' : (pct >= this.cfg.mid ? 'mid' : 'low'); }
    bandLabel(b) {
      var h = this.cfg.high, m = this.cfg.mid;
      return b === 'high' ? 'Grün · ' + h + '–100 %' : (b === 'mid' ? 'Gelb · ' + m + '–' + (h - 1) + ' %' : 'Rot · unter ' + m + ' %');
    }
    missing() { var self = this; return this.items.filter(function (i) { return self.applies(i) && !i.checked; }); }
    completed() { var self = this; return this.items.filter(function (i) { return self.applies(i) && i.checked; }); }
    label(i) { var el = i.closest('[data-kc-li]'); el = el && q(el, '.rn-kc__q'); return el ? el.textContent.trim() : ''; }
    todo(i) { return i.getAttribute('data-todo') || this.label(i); }
    product(i) {
      var h = i.getAttribute('data-product');
      if (!h) return null;
      var tpl = qa(this, 'template[data-kc-product-tpl]').filter(function (t) { return t.getAttribute('data-kc-product-tpl') === h; })[0];
      if (!tpl) return null;
      return { handle: h, tpl: tpl, title: tpl.getAttribute('data-title') || '', url: tpl.getAttribute('data-url') || '', price: tpl.getAttribute('data-price') || '' };
    }
    abs(url) { return /^https?:/i.test(url) ? url : location.origin + url; }
    pageUrl() { return location.origin + location.pathname; }
    resultUrl() { return this.pageUrl() + '#kc=' + this.encode(); }
    nextCheck() { return addMonths(new Date(), this.cfg.months); }

    /* ── Ablauf ──────────────────────────────────────────────── */
    show(name) {
      this.el.intro.hidden = name !== 'intro';
      this.el.quiz.hidden = name !== 'quiz';
      this.el.result.hidden = name !== 'result';
      this.classList.toggle('is-result', name === 'result');
      this.screen = name;
    }
    toTop() {
      var r = this.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.6) this.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
    }
    focusEl(el) { if (el) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } } }
    start() {
      this.index = 0;
      this.applyFilters();
      this.show('quiz');
      this.renderStep(true);
    }
    renderStep(focus) {
      var self = this, flow = this.flow();
      if (this.index > flow.length - 1) this.index = flow.length - 1;
      if (this.index < 0) this.index = 0;
      var cur = flow[this.index];
      this.steps.forEach(function (s) { s.hidden = s !== cur; });
      if (!cur) return;
      cur.classList.remove('is-entering');
      if (!reduced()) { void cur.offsetWidth; cur.classList.add('is-entering'); }
      var areas = flow.filter(function (s) { return s !== self.petStep; });
      flow.forEach(function (s) {
        var num = q(s, '[data-kc-step-num]');
        if (!num) return;
        num.textContent = s === self.petStep ? 'Vorab' : 'Bereich ' + pad(areas.indexOf(s) + 1) + ' / ' + pad(areas.length);
      });
      var n = flow.length, pct = Math.round((this.index + 1) / (n + 1) * 100);
      this.el.progress.setAttribute('aria-valuenow', String(pct));
      this.el.progress.firstElementChild.style.width = pct + '%';
      this.el.progressLabel.textContent = 'Schritt ' + (this.index + 1) + ' von ' + n;
      this.el.nextLabel.textContent = this.index === n - 1 ? 'Auswerten' : 'Weiter';
      this.updateLive();
      if (focus) { this.toTop(); this.focusEl(q(cur, '.rn-kc__step-title')); }
    }
    next() {
      var flow = this.flow(), cur = flow[this.index];
      if (cur && cur === this.petStep && !this.hasChoice()) {
        if (this.el.petsHint) this.el.petsHint.hidden = false;
        return;
      }
      if (this.index >= flow.length - 1) { this.showResult(true); return; }
      this.index++;
      this.renderStep(true);
    }
    prev() {
      if (this.index <= 0) { this.show('intro'); this.toTop(); this.focusEl(q(this, '[data-kc-start]')); return; }
      this.index--;
      this.renderStep(true);
    }
    onSpecies(input) {
      var others = this.speciesInputs.filter(function (i) { return i !== input; });
      if (input.checked && input.value === 'none') others.forEach(function (i) { i.checked = false; });
      if (input.checked && input.value !== 'none') others.forEach(function (i) { if (i.value === 'none') i.checked = false; });
      if (this.el.petsHint) this.el.petsHint.hidden = true;
      this.applyFilters();
      this.renderStep(false);
    }
    setRing(circle, pct) {
      if (!circle) return;
      var v = Math.max(0, Math.min(100, pct));
      circle.setAttribute('stroke-dasharray', v + ' 100');
      circle.style.opacity = v > 0 ? '1' : '0';
    }
    updateLive() {
      var s = this.score();
      if (this.el.liveScore) this.el.liveScore.textContent = s.pct + '\u00a0%';
      this.setRing(this.el.liveRing, s.pct);
      if (this.el.live) {
        this.el.live.classList.remove('is-high', 'is-mid', 'is-low');
        this.el.live.classList.add('is-' + this.band(s.pct));
      }
    }
    restart() {
      this.items.forEach(function (i) { i.checked = false; });
      this.speciesInputs.forEach(function (i) { i.checked = false; });
      this.clearHash();
      this.start();
    }

    /* ── Ergebnis ────────────────────────────────────────────── */
    showResult(animate, opts) {
      opts = opts || {};
      this.applyFilters();
      var s = this.score(), band = this.band(s.pct), b = this.cfg.bands[band] || {};
      this.last = s;
      this.lastBand = band;
      this.show('result');
      this.classList.remove('is-high', 'is-mid', 'is-low');
      this.classList.add('is-' + band);

      q(this, '[data-kc-band-title]').textContent = b.title || '';
      q(this, '[data-kc-band-text]').textContent = b.text || '';
      q(this, '[data-kc-band-range]').textContent = this.bandLabel(band);
      var petNote = q(this, '[data-kc-pet-note]');
      if (petNote) petNote.hidden = !(this.petStep && this.hasPets() && band !== 'high');
      q(this, '[data-kc-stat-done]').textContent = s.done + '/' + s.count;
      q(this, '[data-kc-stat-crit]').textContent = String(s.crit);
      q(this, '[data-kc-stat-next]').textContent = fmtMonth(this.nextCheck());

      var ring = q(this, '[data-kc-ring]'), num = q(this, '[data-kc-score]'), self = this;
      if (animate && !reduced()) {
        this.setRing(ring, 0);
        num.textContent = '0';
        requestAnimationFrame(function () { requestAnimationFrame(function () { self.setRing(ring, s.pct); self.countUp(num, s.pct); }); });
      } else {
        this.setRing(ring, s.pct);
        num.textContent = String(s.pct);
      }

      this.renderTodo();
      this.renderAreas();
      this.renderProducts();
      this.renderDone();
      this.prepareActions();
      this.prepareLead();
      this.writeHash();
      if (!opts.noScroll) { this.toTop(); this.focusEl(q(this, '[data-kc-band-title]')); }
    }
    countUp(el, to) {
      var t0 = null, dur = 900;
      var step = function (t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        el.textContent = String(Math.round(to * e));
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }
    renderTodo() {
      var self = this, wrap = q(this, '[data-kc-todo]'), missing = this.missing();
      wrap.textContent = '';
      if (!missing.length) {
        var ok = document.createElement('div');
        ok.className = 'rn-kc__allgood';
        var st = document.createElement('strong');
        st.textContent = 'Alles erledigt – stark!';
        ok.appendChild(st);
        ok.appendChild(document.createTextNode('Du hast an alles gedacht. Prüf deine Vorräte trotzdem regelmäßig – am besten mit einer Erinnerung im Kalender.'));
        wrap.appendChild(ok);
        return;
      }
      GROUPS.forEach(function (g) {
        var list = missing.filter(function (i) { return self.weight(i) === g.w; });
        if (!list.length) return;
        var group = document.createElement('div');
        group.className = 'rn-kc__group rn-kc__group--' + g.w;
        var head = document.createElement('p');
        head.className = 'rn-mono rn-kc__group-h';
        head.innerHTML = '<span class="rn-kc__mark" aria-hidden="true"></span><b></b><span></span>';
        head.children[1].textContent = g.label;
        head.children[2].textContent = '· ' + list.length;
        var ul = document.createElement('ul');
        ul.className = 'rn-kc__todo-list';
        list.forEach(function (i) {
          var li = document.createElement('li');
          li.innerHTML = '<span class="rn-kc__mark" aria-hidden="true"></span><span class="rn-kc__todo-txt"><span></span></span>';
          li.querySelector('.rn-kc__todo-txt > span').textContent = self.todo(i);
          var p = self.product(i);
          if (p) {
            var a = document.createElement('a');
            a.href = p.url;
            a.textContent = '→ ' + (i.getAttribute('data-note') || ('Passend: ' + p.title));
            li.querySelector('.rn-kc__todo-txt').appendChild(a);
          }
          ul.appendChild(li);
        });
        group.appendChild(head);
        group.appendChild(ul);
        wrap.appendChild(group);
      });
    }
    renderAreas() {
      var self = this, ul = q(this, '[data-kc-areas]');
      ul.textContent = '';
      this.flow().forEach(function (step) {
        if (step === self.petStep) return;
        var total = 0, got = 0;
        qa(step, '[data-kc-item]').forEach(function (i) {
          if (!self.applies(i)) return;
          var w = self.weight(i);
          total += w;
          if (i.checked) got += w;
        });
        if (!total) return;
        var pct = Math.round(got / total * 100);
        var li = document.createElement('li');
        li.className = 'is-' + self.band(pct);
        li.innerHTML = '<span class="rn-kc__area-name"></span><span class="rn-kc__area-pct"></span><span class="rn-kc__area-bar"><span></span></span>';
        li.children[0].textContent = (q(step, '.rn-kc__step-title') || {}).textContent || '';
        li.children[1].textContent = pct + ' %';
        li.children[2].firstChild.style.width = pct + '%';
        ul.appendChild(li);
      });
    }
    productGroups() {
      var self = this, map = {}, order = [];
      this.missing().forEach(function (i) {
        var p = self.product(i);
        if (!p) return;
        if (!map[p.handle]) { map[p.handle] = { p: p, items: [], w: 0 }; order.push(p.handle); }
        map[p.handle].items.push(i);
        map[p.handle].w += self.weight(i);
      });
      order.sort(function (a, b) { return map[b].w - map[a].w; });
      return order.map(function (h) { return map[h]; });
    }
    renderProducts() {
      var self = this, wrap = q(this, '[data-kc-products-wrap]'), grid = q(this, '[data-kc-products]');
      if (!wrap || !grid) return;
      grid.textContent = '';
      var groups = this.productGroups();
      groups.forEach(function (g) {
        var node = g.p.tpl.content.cloneNode(true), n = g.items.length;
        var cover = node.querySelector('[data-kc-cover]');
        if (cover) cover.textContent = n === 1 ? 'Passt zu einem offenen Punkt' : 'Deckt ' + n + ' deiner offenen Punkte ab';
        var list = node.querySelector('[data-kc-cover-list]');
        if (list) g.items.forEach(function (i) { var li = document.createElement('li'); li.textContent = self.todo(i); list.appendChild(li); });
        grid.appendChild(node);
      });
      wrap.hidden = !groups.length;
    }
    renderDone() {
      var self = this, ul = q(this, '[data-kc-done]'), wrap = q(this, '[data-kc-done-wrap]'), count = q(this, '[data-kc-done-count]');
      if (!ul) return;
      ul.textContent = '';
      var done = this.completed();
      done.forEach(function (i) { var li = document.createElement('li'); li.textContent = self.label(i); ul.appendChild(li); });
      if (count) count.textContent = done.length + ' von ' + (done.length + this.missing().length);
      if (wrap) wrap.hidden = !done.length;
    }

    /* ── Mitnehmen: PDF, E-Mail, Kalender ───────────────────── */
    setStatus(t) { if (this.el.status) this.el.status.textContent = t; }
    prepareActions() {
      var g = q(this, '[data-kc-gcal]');
      if (g) g.href = this.googleUrl();
      var tog = q(this, '[data-kc-rem-toggle]');
      if (tog) { tog.setAttribute('aria-expanded', 'false'); var m = document.getElementById(tog.getAttribute('aria-controls')); if (m) m.hidden = true; }
      this.setStatus('');
    }
    toggleReminder(btn) {
      var menu = document.getElementById(btn.getAttribute('aria-controls'));
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      if (menu) menu.hidden = open;
    }
    pdfData() {
      var self = this, s = this.last || this.score(), band = this.lastBand || this.band(s.pct), b = this.cfg.bands[band] || {};
      var missing = this.missing();
      var dis = q(this, '.rn-kc__disclaimer');
      return {
        shop: this.cfg.shop || '',
        title: 'Deine persönliche To-do-Liste',
        date: fmtDate(new Date()),
        next: fmtMonth(this.nextCheck()),
        pct: s.pct, band: band, bandTitle: b.title || '', bandText: b.text || '',
        done: s.done, count: s.count, crit: s.crit,
        groups: GROUPS.map(function (g) {
          return {
            label: g.label, color: g.pdf,
            items: missing.filter(function (i) { return self.weight(i) === g.w; }).map(function (i) {
              var p = self.product(i);
              return { text: self.todo(i), note: p ? (i.getAttribute('data-note') || 'Passend: ' + p.title) : '', url: p ? self.abs(p.url) : '' };
            })
          };
        }).filter(function (g) { return g.items.length; }),
        doneItems: this.completed().map(function (i) { return self.label(i); }),
        products: this.productGroups().map(function (g) {
          return { title: g.p.title, price: g.p.price, url: self.abs(g.p.url), covers: g.items.map(function (i) { return self.todo(i); }) };
        }),
        pageUrl: this.pageUrl(),
        resultUrl: this.resultUrl(),
        disclaimer: dis ? dis.textContent.trim() : ''
      };
    }
    downloadPdf() {
      try {
        var bytes = buildPdf(this.pdfData());
        download(new Blob([bytes], { type: 'application/pdf' }), 'Krisencheck-To-do-Liste.pdf');
        this.setStatus('PDF erstellt: Krisencheck-To-do-Liste.pdf');
      } catch (e) {
        this.setStatus('Das PDF konnte nicht erstellt werden. Nutze alternativ „Drucken“ in deinem Browser.');
        if (window.console) console.error(e);
      }
    }
    sendMail() {
      this.setStatus('Dein E-Mail-Programm öffnet sich – trag einfach deine Adresse ein.');
      window.location.href = this.mailHref();
    }
    mailHref() {
      var self = this, s = this.last || this.score(), b = this.cfg.bands[this.lastBand] || {};
      var subject = 'Mein Krisencheck: ' + s.pct + ' % vorbereitet';
      var head = ['Mein Krisencheck' + (this.cfg.shop ? ' bei ' + this.cfg.shop : '') + ': ' + s.pct + ' % vorbereitet', b.title || '', ''];
      var foot = ['', 'Mein Ergebnis ansehen: ' + this.resultUrl(), 'Nächster Check: ' + fmtMonth(this.nextCheck())];
      var lines = [];
      var missing = this.missing();
      if (!missing.length) lines.push('Alles erledigt – ich bin gut vorbereitet.');
      GROUPS.forEach(function (g) {
        var list = missing.filter(function (i) { return self.weight(i) === g.w; });
        if (!list.length) return;
        lines.push({ head: g.label + ':' });
        list.forEach(function (i) { lines.push({ item: '– ' + self.todo(i) }); });
        lines.push('');
      });
      var compose = function (list, omitted) {
        var body = head.concat(list.map(function (l) { return typeof l === 'string' ? l : (l.head || l.item); }));
        if (omitted) body.push('… und ' + omitted + ' weitere ' + (omitted === 1 ? 'Punkt' : 'Punkte') + ' (siehe Link).');
        return body.concat(foot).join('\r\n');
      };
      var shown = lines.slice(), omitted = 0;
      while (shown.length && encodeURIComponent(compose(shown, omitted)).length > 1800) {
        var cut = shown.pop();
        if (cut && cut.item) omitted++;
      }
      while (shown.length && (shown[shown.length - 1] === '' || shown[shown.length - 1].head)) shown.pop();
      return 'mailto:?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(compose(shown, omitted));
    }
    reminderText() {
      var s = this.last || this.score(), missing = this.missing(), self = this;
      var t = 'Zeit für deinen nächsten Krisencheck' + (this.cfg.shop ? ' bei ' + this.cfg.shop : '') + '.\n';
      t += 'Letztes Ergebnis: ' + s.pct + ' % vorbereitet.\n';
      if (missing.length) {
        t += 'Noch offen waren: ' + missing.slice(0, 8).map(function (i) { return self.todo(i); }).join('; ') + (missing.length > 8 ? ' …' : '') + '\n';
      }
      t += 'Kurz prüfen: Haltbarkeit von Wasser, Lebensmitteln, Futter und Medikamenten – Powerbank laden, Batterien tauschen.\n\n';
      t += 'Zum Krisencheck: ' + this.pageUrl();
      return t;
    }
    downloadIcs() {
      var start = this.nextCheck(), end = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 1);
      var stamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
      var title = 'Krisencheck wiederholen';
      var lines = [
        'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//' + icsEscape(this.cfg.shop || 'Shop') + '//Krisencheck//DE',
        'CALSCALE:GREGORIAN', 'METHOD:PUBLISH', 'BEGIN:VEVENT',
        'UID:krisencheck-' + stamp + '-' + Math.random().toString(36).slice(2, 10) + '@' + (location.hostname || 'shop'),
        'DTSTAMP:' + stamp, 'DTSTART;VALUE=DATE:' + ymd(start), 'DTEND;VALUE=DATE:' + ymd(end),
        'SUMMARY:' + icsEscape(title), 'DESCRIPTION:' + icsEscape(this.reminderText()), 'URL:' + this.pageUrl(),
        'TRANSP:TRANSPARENT',
        'BEGIN:VALARM', 'ACTION:DISPLAY', 'DESCRIPTION:' + icsEscape(title), 'TRIGGER:PT9H', 'END:VALARM',
        'END:VEVENT', 'END:VCALENDAR'
      ];
      download(lines.map(icsFold).join('\r\n') + '\r\n', 'Krisencheck-Erinnerung.ics', 'text/calendar;charset=utf-8');
      this.setStatus('Kalender-Datei gespeichert – öffnen, um den Termin am ' + fmtDate(start) + ' einzutragen.');
    }
    googleUrl() {
      var start = this.nextCheck(), end = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 1);
      return 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent('Krisencheck wiederholen') +
        '&dates=' + ymd(start) + '/' + ymd(end) + '&details=' + encodeURIComponent(this.reminderText());
    }

    /* ── Newsletter (optional) ──────────────────────────────── */
    prepareLead() {
      var form = q(this, '.rn-kc__form');
      if (!form) return;
      var s = this.last || this.score(), band = this.band(s.pct), now = new Date(), base = this.cfg.tag || 'krisencheck';
      var extra = String(this.cfg.extraTags || '').split(',').map(function (t) { return t.trim().toLowerCase().replace(/\s+/g, '-'); });
      var tags = extra.concat([base, base + '-' + now.getFullYear() + '-' + pad(now.getMonth() + 1), 'krisenscore-' + s.pct,
        'krisenscore-' + ({ high: 'gruen', mid: 'gelb', low: 'rot' })[band]]);
      var sp = this.species();
      Object.keys(sp).forEach(function (k) { if (SPECIES_TAG[k]) tags.push('tier-' + SPECIES_TAG[k]); });
      this.missing().forEach(function (i) { var t = i.getAttribute('data-tag'); if (t) tags.push('fehlt-' + t); });
      var input = q(form, '[data-kc-tags]');
      if (input) input.value = uniq(tags).join(', ');
      var rt = q(form, 'input[name="return_to"]');
      if (rt) rt.value = location.pathname + '#kc=' + this.encode() + '&kc-sent=1';
    }
    beforeLeadSubmit() {
      this.prepareLead();
      try { sessionStorage.setItem('rn-kc-pending', this.encode()); } catch (e) { /* optional */ }
    }

    /* ── Ergebnis-Link (#kc=…) ──────────────────────────────── */
    encode() {
      var bits = [], s = this.species();
      SPECIES.forEach(function (k) { bits.push(s[k] ? 1 : 0); });
      this.items.forEach(function (i) { bits.push(i.checked ? 1 : 0); });
      var bin = '';
      for (var b = 0; b < bits.length; b += 8) {
        var v = 0;
        for (var k = 0; k < 8; k++) v = (v << 1) | (bits[b + k] || 0);
        bin += String.fromCharCode(v);
      }
      return '1.' + this.items.length.toString(36) + '.' + btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    }
    decode(code) {
      var m = /^1\.([0-9a-z]+)\.([A-Za-z0-9_-]+)$/.exec(code || '');
      if (!m || parseInt(m[1], 36) !== this.items.length) return false;
      var bin;
      try { bin = atob(m[2].replace(/-/g, '+').replace(/_/g, '/')); } catch (e) { return false; }
      var bits = [];
      for (var i = 0; i < bin.length; i++) { var v = bin.charCodeAt(i); for (var k = 7; k >= 0; k--) bits.push((v >> k) & 1); }
      this.speciesInputs.forEach(function (inp) { inp.checked = !!bits[SPECIES.indexOf(inp.value)]; });
      this.items.forEach(function (inp, idx) { inp.checked = !!bits[SPECIES.length + idx]; });
      return true;
    }
    writeHash() { try { history.replaceState(history.state, '', location.pathname + location.search.replace(/[?&]customer_posted=true/, '') + '#kc=' + this.encode()); } catch (e) { /* ignore */ } }
    clearHash() { try { history.replaceState(history.state, '', location.pathname + location.search.replace(/[?&]customer_posted=true/, '')); } catch (e) { /* ignore */ } }
    restore() {
      var hash = location.hash || '', m = /[#&]kc=([A-Za-z0-9._-]+)/.exec(hash), code = m ? m[1] : null;
      var sent = /kc-sent=1/.test(hash) || /customer_posted=true/.test(location.search);
      var ok = q(this, '[data-kc-form-ok]'), err = q(this, '[data-kc-form-err]');
      var postedOk = !!(ok && !ok.hidden);
      var pending = null;
      try { pending = sessionStorage.getItem('rn-kc-pending'); sessionStorage.removeItem('rn-kc-pending'); } catch (e) { /* ignore */ }
      if (!code && pending && (sent || postedOk || err)) code = pending;
      if (!code || !this.decode(code)) return false;
      this.showResult(false, { noScroll: true });
      if (sent && !err && ok) {
        ok.hidden = false;
        qa(this, '.rn-kc__form-row, .rn-kc__consent').forEach(function (el) { el.hidden = true; });
      }
      var target = (sent || postedOk || err) ? q(this, '.rn-kc__lead-box') : this;
      if (target) requestAnimationFrame(function () { target.scrollIntoView({ block: 'start' }); });
      return true;
    }

    /* ── Theme-Editor ───────────────────────────────────────── */
    editorGoto(where) {
      if (where === 'intro') { this.show('intro'); return; }
      if (where === 'demo') {
        this.speciesInputs.forEach(function (i) { i.checked = i.value === 'dog' || i.value === 'cat'; });
        this.applyFilters();
        this.items.forEach(function (i, idx) { i.checked = idx % 3 !== 0; });
        this.showResult(true, { noScroll: true });
        return;
      }
      if (where === 'first' && this.petStep && !this.hasChoice()) {
        this.speciesInputs.forEach(function (i) { i.checked = i.value === 'dog'; });
      }
      this.applyFilters();
      this.index = (where === 'first' && this.petStep) ? 1 : 0;
      this.show('quiz');
      this.renderStep(false);
    }
    editorSelect(target) {
      var step = target.closest('[data-kc-step]');
      if (!step) return;
      this.show('quiz');
      this.steps.forEach(function (s) { s.hidden = s !== step; });
      qa(step, '[data-kc-li]').forEach(function (li) { li.hidden = false; });
    }
  }

  customElements.define('rn-krisencheck', RNKrisencheck);
})();